import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { idPropType } from "constants/app";
import { shape, string } from "prop-types";
import { useDispatch } from "react-redux";
import { retrySiteAccess } from "slices/sharepoint/actions";

const RetryAccessAction = ({ item }) => {
  const dispatch = useDispatch();

  const handleRetry = (e) => {
    e.stopPropagation();
    dispatch(retrySiteAccess(item.id));
  };

  return (
    <NewButton
      variant={NewButtonVariant.l4}
      size={NewButtonSize.sm}
      onClick={handleRetry}
      aria-label={`Retry access check for ${item.name}`}
    >
      Retry
    </NewButton>
  );
};

RetryAccessAction.propTypes = {
  item: shape({
    id: idPropType.isRequired,
    name: string.isRequired,
  }).isRequired,
};

export default RetryAccessAction;
